export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_FAIL="LOGIN_FAIL"
export const LOGIN_REQUEST="LOGIN_REQUEST"
export const LOG_OUT="LOG_OUT"
export const LOAD_PROFILE="LOGIN_PROFILE"

export const HOME_VIDEO_SUCCESS ="HOME_VIDEO_SUCCESS"
export const HOME_VIDEO_FAIL="HOME_VIDEO_FAIL"
export const HOME_VIDEO_REQUEST="HOME_VIDEO_REQUEST"